import { FC } from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  Container,
  Typography,
} from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import PageHeader from 'src/components/NewRenterInterface/PageHeader/PageHeader';
import { NotificationList } from 'src/components/Notifications';
import { useNotifications } from 'src/contexts/NotificationContext';
import { useRenterNotificationGateV2 } from 'src/hooks/useRenterNotificationGateV2';
import {
  getNotificationSourceValue,
  NOTIFICATION_SOURCE_TYPES,
} from 'src/utils/notificationFields';

const RenterNotificationsPage: FC = () => {
  const { notifications, loading, error } = useNotifications();
  const { isEnabled, loading: gateLoading } = useRenterNotificationGateV2();

  const renterNotifications = notifications.filter(
    (notification) =>
      getNotificationSourceValue(notification) ===
      NOTIFICATION_SOURCE_TYPES.RENTER
  );

  return (
    <Box sx={{ backgroundColor: 'background.default', minHeight: '100vh' }}>
      <PageHeader title="Notifications" icon={<NotificationsActiveIcon />} />
      <Container sx={{ py: 3 }}>
        {gateLoading ? (
          <Box display="flex" justifyContent="center" py={6}>
            <CircularProgress />
          </Box>
        ) : !isEnabled ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            py={6}
          >
            <Typography variant="h6" color="text.secondary" gutterBottom>
              Notifications are disabled
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Household notifications aren&apos;t enabled for your property yet.
            </Typography>
          </Box>
        ) : (
          <>
            {loading && (
              <Box display="flex" justifyContent="center" py={3}>
                <CircularProgress />
              </Box>
            )}
            {error && (
              <Alert severity="error" sx={{ mb: 3 }}>
                {error}
              </Alert>
            )}
            {!loading && (
              <NotificationList
                notifications={renterNotifications}
                showCheckbox={false}
              />
            )}
          </>
        )}
      </Container>
    </Box>
  );
};

export default RenterNotificationsPage;
